module.exports = __webpack_public_path__ + "static/media/hilton-logo.60dfdc84.svg";